import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Divider,
  Typography,
} from '@mui/material';
import { useState } from 'react';

const PrintModule = ({
  settingsSlot,
  title,
  checked,
  description,
  onCheckedChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  // MUI imports

  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded((prev) => !prev)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          alignItems: 'center',
        }}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          sx={{ mr: 1.5 }}
        />
        <Typography sx={{ flex: 1, fontWeight: 500 }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, py: 2 }}>
        <Typography sx={{ mb: 1.5 }}>{description}</Typography>
        <Divider sx={{ my: 1.5 }} />
        <Box>{settingsSlot}</Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default PrintModule;
